import { startOfMonth, endOfMonth } from 'date-fns';

export interface CustomTimeframe {
  start: Date;
  end: Date;
}

export function getCustomTimeframe(targetYear: number, targetMonth: number, customStartDay: number): CustomTimeframe {
  if (customStartDay === 1) {
    return {
      start: startOfMonth(new Date(targetYear, targetMonth - 1)),
      end: endOfMonth(new Date(targetYear, targetMonth - 1))
    };
  }

  // Helper function to get the actual start day, handling month-end edge cases
  const getActualStartDay = (year: number, month: number, requestedDay: number): number => {
    // Get the last day of the target month
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    // Use the requested day or the last day of the month, whichever is smaller
    return Math.min(requestedDay, lastDayOfMonth);
  };

  let periodStart: Date;
  let periodEnd: Date;

  if (customStartDay <= 15) {
    const actualStartDay = getActualStartDay(targetYear, targetMonth, customStartDay);
    periodStart = new Date(targetYear, targetMonth - 1, actualStartDay);

    const nextMonth = targetMonth === 12 ? 1 : targetMonth + 1;
    const nextYear = targetMonth === 12 ? targetYear + 1 : targetYear;
    const actualEndDay = getActualStartDay(nextYear, nextMonth, customStartDay) - 1;
    // Handle edge case where actualEndDay becomes 0 (need last day of previous month)
    if (actualEndDay <= 0) {
      const prevEndMonth = nextMonth === 1 ? 12 : nextMonth - 1;
      const prevEndYear = nextMonth === 1 ? nextYear - 1 : nextYear;
      const lastDayOfPrevMonth = new Date(prevEndYear, prevEndMonth, 0).getDate();
      periodEnd = new Date(prevEndYear, prevEndMonth - 1, lastDayOfPrevMonth, 23, 59, 59, 999);
    } else {
      periodEnd = new Date(nextYear, nextMonth - 1, actualEndDay, 23, 59, 59, 999);
    }
  } else {
    const prevMonth = targetMonth === 1 ? 12 : targetMonth - 1;
    const prevYear = targetMonth === 1 ? targetYear - 1 : targetYear;
    const actualStartDay = getActualStartDay(prevYear, prevMonth, customStartDay);
    periodStart = new Date(prevYear, prevMonth - 1, actualStartDay);

    const actualEndDay = getActualStartDay(targetYear, targetMonth, customStartDay) - 1;
    // Handle edge case where actualEndDay becomes 0 (need last day of previous month)
    if (actualEndDay <= 0) {
      const prevEndMonth = targetMonth === 1 ? 12 : targetMonth - 1;
      const prevEndYear = targetMonth === 1 ? targetYear - 1 : targetYear;
      const lastDayOfPrevMonth = new Date(prevEndYear, prevEndMonth, 0).getDate();
      periodEnd = new Date(prevEndYear, prevEndMonth - 1, lastDayOfPrevMonth, 23, 59, 59, 999);
    } else {
      periodEnd = new Date(targetYear, targetMonth - 1, actualEndDay, 23, 59, 59, 999);
    }
  }

  return { start: periodStart, end: periodEnd };
}
